/* eslint-disable react/prop-types */
import React from "react"; // React Stuff
import SpecialRequirements from "../../common/SpecialRequirementsTooltip.js";
import Moment from "react-moment";
import { Col, Row, Button, Table } from "react-bootstrap";
import { Link } from "react-router-dom";

const BlockIssueReports = (props) => {
  return (
    <Row className='mt-4 mb-4 text-center'>
      <Col className='border shadow p-3'>
        <h3 className='mt-4'>Progress &amp; Awards</h3>
        <p>
          You can issue progress reports against the class types grading criteria here. Awards can
          be configured in the award section.
        </p>
        {props.data.Participants.length > 0 ? (
          <Table striped bordered hover responsive size='sm' className='text-center'>
            <thead>
              <tr>
                <th>Name</th>
                <th>Progress</th>
                <th>Awards</th>
              </tr>
            </thead>
            <tbody>
              {props.data.Participants.map((participant) => (
                <tr key={participant._id}>
                  <td className='align-self-center align-middle'>
                    <small>
                      {`${participant.First_Name} ${participant.Last_Name}`}
                      {participant.Special_Requirements && (
                        <SpecialRequirements
                          specialRequirements={participant.Special_Requirements}
                        />
                      )}
                    </small>
                    <br />
                    <span className='smallprint'>
                      (
                      <Moment format='Y [year], M [months]' durationFromNow ago>
                        {participant.Date_Of_Birth}
                      </Moment>{" "}
                      old)
                    </span>
                  </td>
                  <td className='align-self-center align-middle'>
                    <Button
                      variant='success'
                      size='sm'
                      type='link'
                      as={Link}
                      to={`/tutor/reportcards/block/${props.data._id}/${participant._id}`}
                    >
                      Progress
                    </Button>
                  </td>
                  <td className='align-self-center align-middle'>
                    <Button
                      variant='warning'
                      size='sm'
                      type='link'
                      as={Link}
                      to={`/tutor/award-participant/${participant._id}`}
                    >
                      Award
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          <p>No Subscribers yet...</p>
        )}
      </Col>
    </Row>
  );
};

export default BlockIssueReports;
